import * as React from 'react';
import { IAPanel } from '../../../../panels/Panel';
import * as styles from "./Panel.css";
import { IAButton } from '../../../../button/Button';
import { LocalizationService } from '../../../../../services/LocalizationService';
import { ITargetingGroup } from '../../../../../interfaces/ITargetingGroup';
import { IACheckbox } from '../../../../checkbox/Checkbox';
import { IAMessageBar } from '../../../../messageBar/MessageBar';

export interface IProps {
  open: boolean;
  availableGroups: ITargetingGroup[];
  highlightColor: string;
  onClose: () => void;
  onSave: (groupIds: number[]) => void;
}

export interface IState {
  availableGroups: any[];
}

export default class ADGroupPanel extends React.Component<IProps, IState> {

  constructor(props, state) {
    super(props, state);
    this.state = {
      availableGroups: []
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.open !== this.props.open) {
      const availableGroups: any = props.availableGroups;
      availableGroups?.forEach((group) => {
        group.checked = false;
      });
      this.setState({
        availableGroups
      });
    }
  }

  private onClose(): void {
    this.setState({ availableGroups: undefined }, () => {
      this.props.onClose();
      document.body.style.height = "inherit";
      document.body.style.overflowY = "auto";
    });
  }

  public render(): JSX.Element {
    const checkboxes = [];
    let allInUse = true;
    this.state.availableGroups?.forEach((group: ITargetingGroup, index) => {
      if (!group.disabled) {
        allInUse = false;
      }
      checkboxes.push(
        <IACheckbox
          highlightColor={this.props.highlightColor}
          disabled={group.disabled}
          isChecked={this.state.availableGroups[index].checked}
          label={group.title}
          styles={{
            float: "left",
            clear: "both",
            marginTop: 10
          }}
          onChange={() => {
            let availableGroups = this.state.availableGroups;
            availableGroups[index].checked = !availableGroups[index].checked;
            this.setState({ availableGroups });
          }}
        />
      );
    })
    return (
      <div>
        <IAPanel
          showNavigationBar={true}
          open={this.props.open}
          transition={"slide"}
          width={550}
          isMobile={false}
          close={() => this.onClose()}
        >
          <div
            className={styles.IA_viewPanelContentWrapper}
            style={{
              marginTop: 20,
              height: window.innerHeight - 130
            }}
          >
            {allInUse &&
              <IAMessageBar
                type="information"
                content={new LocalizationService().strings.TargetingAdmin_AllADGroupInUse}
                style={{
                  borderRadius: 5,
                  marginBottom: 10
                }}
                onDismiss={() => { }}
              />
            }
            {checkboxes}
            <div style={{ position: 'fixed', bottom: 15}}>
              <IAButton
                style={{ float: 'left' }}
                borderRadius={5}
                buttonColor={this.props.highlightColor}
                label={new LocalizationService().strings.Admin_Add}
                disbaled={false}
                onClick={() => {
                  const groupIdsToAdd = [];
                  this.state.availableGroups.forEach((group) => {
                    if (group.checked && !group.disabed) {
                      groupIdsToAdd.push(group.id);
                    }
                  });
                  document.body.style.height = "inherit";
                  document.body.style.overflowY = "auto";
                  this.props.onSave(groupIdsToAdd);
                }}
              />
              <IAButton
                label={new LocalizationService().strings.TargetingAdmin_PropertyPanelCancel}
                buttonColor={"#999999"}
                borderRadius={5}
                style={{ marginLeft: "10px", float: 'right' }}
                onClick={() => {
                  this.onClose();
                }}
              />
            </div>
          </div>
        </IAPanel>
      </div>
    );
  }
}